module.exports = __webpack_public_path__ + "static/media/5.7ce1414f.svg";